<template>

    <div class="order-error" v-if=" orderError != null ">

        <font-awesome-icon style="font-size: 30px;" icon="exclamation-triangle" />
        <p>

            {{ orderError }}
        </p>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';
    import FontAwesomeIcon from '@fortawesome/vue-fontawesome';

    export default {

        name: 'order-error',
        computed: {

            ...mapGetters({

                orderError          : 'orderTab/orderError'
            })
        },
        components: {

            FontAwesomeIcon
        }
    }
</script>

<style scoped>


    .order-error {

        border-top: 1px solid rgba( 225, 35, 35, 0.75);
        border-bottom: 1px solid rgba( 225, 35, 35, 0.75);
        background-color: rgba(225, 35, 35, 0.1);
        text-align: center;
        padding: 45px 15px;
        margin: 10px 0;
        color: red;
        font-size: 18px;
        font-weight: 500;
    }
</style>


